import * as React from 'react';
import { connect } from 'react-redux';

import IState, { IReportTemplatesState } from '../../interfaces/states';
import { ReportTemplate } from '../../store/models';

import {
    Modal as ModalAction,
    ReportTemplate as ReportTemplateAction
} from '../../actions';

import OpenModal from './OpenModal';
import LoadingModal from './LoadingModal';

interface IOwnProps {
    activeModal: string,
    onClose: Function,
}

interface IStateProps {
    templates: IReportTemplatesState
}

interface IDispatchProps {
    listTemplates: Function,
    removeTemplate: Function,
    openTemplate: Function,
}

type IProps = IOwnProps & IStateProps & IDispatchProps;

class OpenModalContainer extends React.Component<IProps, void> {
    static propTypes = {
        activeModal: React.PropTypes.string,
        onClose: React.PropTypes.func.isRequired,
        removeTemplate: React.PropTypes.func.isRequired,
        listTemplates: React.PropTypes.func.isRequired,
    };

    isActive(activeModal: string) {
        return activeModal === 'open';
    }

    openTemplate(template: ReportTemplate) {
        this.props.openTemplate(template);
        this.props.onClose();
    }

    removeTemplate(template: ReportTemplate) {
        this.props.removeTemplate('open', template.rtId);
    }

    componentDidUpdate(prevProps: IProps) {
        if (!this.isActive(prevProps.activeModal) && this.isActive(this.props.activeModal)) {
            this.props.listTemplates();
        }
    }

    render() {
        const { templates } = this.props;

        if (templates.loading) {
            return (
                <LoadingModal widgetName='OpenModalContainer' />
            );
        }

        const templateList = templates.arr.map(rtId => templates.byId[rtId]);

        return (
            <OpenModal
                active={this.isActive(this.props.activeModal)}
                onOpen={this.openTemplate.bind(this)}
                onClose={this.props.onClose}
                onRemove={this.removeTemplate.bind(this)}
                templates={templateList}
            />
        );
    }
}

function mapStateToProps(state: IState) {
    return {
        templates: state.reportTemplates
    }
};

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    {
        openTemplate: ReportTemplateAction.open,
        removeTemplate: ReportTemplateAction.remove,
        listTemplates: ReportTemplateAction.loadAll,
    }
)(OpenModalContainer);


// WEBPACK FOOTER //
// ./src/components/modal/OpenModalContainer.tsx